import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-layout h-100 px-2 overflow-auto" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = {
  class: "page-content",
  id: "App__Central"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "embed-responsive embed-responsive-1by1 ratio ratio-1*1" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    id: "hh-video",
    allowfullscreen: "",
    src: "https://www.youtube.com/embed/PvexmWMy--E"
  }, " ")
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CentralDashboardHeader = _resolveComponent("CentralDashboardHeader")!
  const _component_PersonalMessageList = _resolveComponent("PersonalMessageList")!
  const _component_ActivePatients = _resolveComponent("ActivePatients")!
  const _component_UnassignedVisits = _resolveComponent("UnassignedVisits")!
  const _component_Intake = _resolveComponent("Intake")!
  const _component_Scheduled = _resolveComponent("Scheduled")!
  const _component_MarketingVideo = _resolveComponent("MarketingVideo")!
  const _component_NewsAndUpdates = _resolveComponent("NewsAndUpdates")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createVNode(_component_CentralDashboardHeader)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_PersonalMessageList, { class: "row-span-2" }),
      _createVNode(_component_ActivePatients),
      (_ctx.showScheduler)
        ? (_openBlock(), _createBlock(_component_UnassignedVisits, { key: 0 }))
        : _createCommentVNode("v-if", true),
      (_ctx.showIntake)
        ? (_openBlock(), _createBlock(_component_Intake, { key: 1 }))
        : _createCommentVNode("v-if", true),
      (_ctx.showScheduler)
        ? (_openBlock(), _createBlock(_component_Scheduled, { key: 2 }))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_MarketingVideo, null, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_NewsAndUpdates, {
        class: _normalizeClass(_ctx.colSpan)
      }, null, 8 /* PROPS */, ["class"])
    ])
  ]))
}